import { classes } from "typestyle";
import Icon from "../icon/icon.component";
import {
  checkListActiveItemClassName,
  checkListClassName,
  checkListItemClassName
} from "./checklist.style";

interface CheckListProps {
  children?: React.ReactNode;
}

interface CheckListItemProps {
  checked?: boolean;
  children?: React.ReactNode;
}

const CheckList = ({
  children
}: CheckListProps) => (
  <ul className={ checkListClassName }>{ children }</ul>
);

CheckList.Item = ({
  checked = false,
  children
}: CheckListItemProps) => (
    <li
        className={ classes(
            checkListItemClassName,
            checked && checkListActiveItemClassName
        ) }>
            <Icon name='check'/>
            { children }
    </li>
);

export default CheckList;
